import { render } from "./MarketPlaceFooterCarousel.vue?vue&type=template&id=6b847141&scoped=true"
import script from "./MarketPlaceFooterCarousel.vue?vue&type=script&lang=js"
export * from "./MarketPlaceFooterCarousel.vue?vue&type=script&lang=js"

import "./MarketPlaceFooterCarousel.vue?vue&type=style&index=0&id=6b847141&scoped=true&lang=scss"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b847141"]])

export default __exports__